import { verQuery } from "./assetsVersionForCache"

let apiEndpoint
let endpointPath
let basePath = "/"
if (process.env.VUE_APP_APP_BASE_PATH) {
  basePath = process.env.VUE_APP_APP_BASE_PATH
}

async function getData(endpoint) {
  const response = await fetch(endpoint)

  if (response.ok) {
    const data = await response.json()
    return data
  }

  return
}

export async function getMetaInvestmentData() {
  try {
    const meta = await getData(`${basePath}/meta.json?${verQuery}`)
    apiEndpoint = await meta.api
    endpointPath = await meta.endpointPath
    return await meta
  } catch (error) {
    console.error(error)
    throw error
  }
}

export async function getMetaApartmentData(apartmentNumber) {
  try {
    return await getData(`${endpointPath}/apartments/${apartmentNumber}/data.json?${verQuery}`)
  } catch (error) {
    console.error(error)
    throw error
  }
}

export async function getApiData() {
  try {
    return await getData(apiEndpoint)
  } catch (error) {
    console.error(error)
    throw error
  }
}
